module.exports = __webpack_public_path__ + "img/sp1.32282c7d.jpg";